import * as core from '../../../../../../../core'

import { query } from './traceability-matrix-unverified.query'

export const RESOURCE = {
  payload: {
    alias: 'traceability-matrix.unverified',
    description: 'Count of requirements built but not yet tested',
    name: 'Traceability Matrix - Unverified',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
